import React from 'react'
import '../css/footer.scss'
import call from '../assets/images/icons/llamada-telefonica.png'
import correo from '../assets/images/icons/correo-electronico.png'
import whatsapp  from '../assets/images/icons/whatsapp.png'
import { Link } from 'react-router-dom'
export default function Footer() {
    return (
        <section className='footer'>
            <div className='container'>
                <div className='footer-content'>
                    <div className='footer-content-box'>
                        <div className='footer-box'>
                            <ul>
                                <li><h4>Contáctanos</h4></li>
                                <li><a href="tel:8003377437" aria-label="Llamar por teléfono">                                    
                                        <img src={call} alt='baja ferries call center' />
                                        <span>Llámanos al 800 337 7437</span>
                                    </a>                                    
                                </li>
                                <li>
                                    <a href="mailto:contactcenter@bajaferries.com.mx" rel="noopener noreferrer" aria-label="Contactar por correo"><img src={correo} alt='correo baja ferries' />contactcenter@bajaferries.com.mx </a>
                                    </li>
                                <li><img src={whatsapp} alt='whatsapp baja ferries' /><a href="https://wa.me/+528003377437?text=Me%20interesa%20una%20cotización" target="_blank" rel="noopener noreferrer" aria-label="Contactar por WhatsApp">WhatsApp</a> </li>     
                                                         
                            </ul>
                        </div>
                        <div className='footer-box'>
                            <ul>
                                <li><h4>De tu interés</h4></li>
                                <li><a href="https://apibcs.com.mx/" rel="noopener noreferrer" target="_blank" aria-label="ASIPONA Mazatlán">API BCS</a>  </li>
                                <li><a href="https://www.puertotopolobampo.com.mx/" rel="noopener noreferrer" target="_blank" aria-label="ASIPONA Topolobampo">ASIPONA Topolobampo</a>  </li>
                                <li><a href="https://www.puertomazatlan.com.mx/" rel="noopener noreferrer" target="_blank" aria-label="ASIPONA Mazatlán">ASIPONA Mazatlán</a>  </li>

                              


                            </ul>
                        </div>
                    </div>
                     <div className='footer-content-box'>
                        <div className='footer-box'>
                            <ul>
                                <li><h4>Antes de viajar</h4></li>
                                <li><Link to='/como-llegar'>Llegar al puerto</Link></li>
                                <li><Link to='/equipaje'>Equipaje</Link></li>                                
                                <li><Link to='/listo-para-viajar'>¿Listo para viajar?</Link></li>
                            </ul>
                        </div>
                        <div className='footer-box'>
                            <ul>
                                <li><h4>Durante tu viaje</h4></li>
                                <li><a href="https://www.bajaferries.com.mx/menuqr/cabo-star.pdf" rel="noopener noreferrer"  target="_blank" aria-label="menu">Menú Cabo Star</a></li>
                                <li><a href="https://www.bajaferries.com.mx/menuqr/california-star.pdf" rel="noopener noreferrer" target="_blank" aria-label="menu">Menú California Star</a></li>
                                <li><a href="https://www.bajaferries.com.mx/menuqr/bar-exterior.pdf" rel="noopener noreferrer" target="_blank" aria-label="menu">Menú bar exterior</a></li>

                                
                            </ul>
                        </div>
                        <div className='footer-box'>
                            <ul>
                                <li><h4>Al llegar</h4></li>
                                <li><Link to='/desembarque-pasajero'>Desembarque pasajero</Link></li>
                                <li><Link to='/desembarque-con-automovil'>Desembarque con automóvil</Link></li>
                                <li><Link to='/desembarque-con-unidades-de-carga'>Desembarque con unidades de carga</Link></li>
                                
                            </ul>
                        </div>

                    </div>

                </div>
                <div className='copyright'>
                    <label>Copyright © BAJA FERRIES S.A.P.I. DE C.V. 2026. Todo los derechos reservados.</label>
                    <div className='copyright-content'>                    
                        <span><a href="https://www.bajaferries.com.mx/condiciones-de-servicio" rel="noopener noreferrer" target="_blank" aria-label="Condiciones de servicio">Condiciones de servicio</a></span>
                        <label><a href="https://www.bajaferries.com.mx/aviso-de-privacidad" rel="noopener noreferrer" target="_blank" aria-label="Aviso de privacidad">Aviso de privacidad</a></label>
                        
                    </div>
                </div>
            </div>
        </section>
    )                      
    
    

}
